import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalStructureList extends BaseModelAPI {

	static entity = 'approvalstructurelist'
	static entityName = 'approvalstructure';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
